import { APICaller, useAPICaller } from "@api/request";
import { getImage } from "@api/services/imageService";
import { LibraryBooks, Person } from "@mui/icons-material";
import { Avatar } from "@mui/material";
import { useEffect, useRef, useState } from "react";

const TFFDMAvatar = ({
    imageUrl,
    variant,
    height,
    width,
    isDeservingItem
}: {
    imageUrl?: string;
    variant?: "circular" | "square" | "rounded";
    height?: number;
    width?: number;
    isDeservingItem?: boolean
}) => {
    const APICallerRef = useRef<APICaller>(useAPICaller());
    const [imageSrc, setImageSrc] = useState<string>("");

    useEffect(() => {
        if (imageUrl) {
            getImageSrc(imageUrl);
        }
    }, [imageUrl]);

    const getImageSrc = async (imageUrl: string) => {
        try {
            const { data: imageSrcData } = await getImage(imageUrl, APICallerRef.current);
            setImageSrc(imageSrcData);
        } catch (error: any) {
            // eslint-disable-next-line
        }
    };

    return <Avatar variant={variant ?? "circular"} src={imageSrc} sx={{ height: height ?? 40, width: width ?? 40 }} >{isDeservingItem ? <LibraryBooks /> : <Person />}</Avatar>;
};

export default TFFDMAvatar;
